import { SwitchButton } from "components/switchButton";
import { IAttractionQRCodeItem } from "interfaces";
import { Link } from "react-router-dom";
import Button from "components/button";
import { EyeIcon } from "@heroicons/react/outline";
import { TooltipParagraph } from "components/tooltipParagraph";
import { get } from "lodash";
import moment from "moment";
import { Tag } from "components/tag";
import { getAttractionQRCodeSendingStatus, isHaveActionPermission } from "utills/helpers";

interface AttractionQRCodeTableProps {
  data?: IAttractionQRCodeItem[];
  pageSize: number;
  currentPage: number;
  _toggleActive: (id: string, isActive: boolean) => void;
}

export const AttractionQRCodeTable = ({
  data = [],
  pageSize = 10,
  currentPage = 1,
  _toggleActive,
}: AttractionQRCodeTableProps) => {
  return (
    <div className="flow-root">
      <div className="relative inline-block w-full align-middle box-border">
        <table className="w-full divide-y divide-gray-300 bg-magnolia-500 rounded-md">
          <thead>
            <tr>
              <th scope="col" className="th py-3.5 pl-4 pr-3 sm:pl-6 lg:pl-8">
                No
              </th>
              <th scope="col" className="th">
                Code
              </th>
              <th scope="col" className="th">
                Ticket name
              </th>
              <th scope="col" className="th">
                Event  name
              </th>
              <th scope="col" className="th">
                Code sending status
              </th>
              <th scope="col" className="th">
                Status
              </th>
              <th scope="col" className="th">
                Created date
              </th>
              <th scope="col" className="th w-28">
                <span className="sr-only">Action</span>
                <p className="">Action</p>
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white">
            {data.map((item: IAttractionQRCodeItem, index: number) => (
              <tr key={index}>
                <td className="td py-4 pl-4 pr-3 sm:pl-6 lg:pl-8">
                  {(currentPage - 1) * pageSize + 1 + index}
                </td>
                <td className="td">
                  {item.code}
                </td>
                <td className="td max-w-20 overflow-x-auto">
                  <TooltipParagraph 
                    text={get(item, "ticket.name_en", "")}
                    className="whitespace-pre-wrap max-w-[280px]"
                  />
                </td>
                <td className="td max-w-20 overflow-x-auto">
                  <TooltipParagraph 
                    text={get(item, "event.name_en", "")}
                    className="whitespace-pre-wrap max-w-[280px]"
                  />
                </td>
                <td className="td">
                  <Tag text={getAttractionQRCodeSendingStatus(item.status)} type={item.status} />
                </td>
                <td className="td">
                  <SwitchButton
                    checked={item.is_active}
                    disabled={!isHaveActionPermission("attractions_qr_code", "events", "edit")}
                    onChange={() => _toggleActive(item.id, item.is_active)}
                  />
                </td>
                <td className="td">
                  {item.created_at ? moment(item.created_at).format("DD/MM/YYYY HH:mm:ss") : ""}
                </td>
                <td className="td flex gap-x-2 py-4 pl-3 pr-4 sm:pr-6 lg:pr-8">
                  <Link to={`/events/attraction-qr-code/${item.id}`} className="w-fit">
                    <Button className="w-8 h-8 bg-gray-200 hover:bg-gray-100 active:bg-gray-300">
                      <EyeIcon className="w-4 h-4 text-black" />
                    </Button>
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
